import { render, staticRenderFns } from "./storeCommendReq.vue?vue&type=template&id=59822448&scoped=true&"
import script from "./storeCommendReq.vue?vue&type=script&lang=js&"
export * from "./storeCommendReq.vue?vue&type=script&lang=js&"
import style0 from "./storeCommendReq.vue?vue&type=style&index=0&id=59822448&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59822448",
  null
  
)

export default component.exports